import React, { useEffect } from 'react';
import HeaderComponent from "../Header/component"
import FooterComponent from "../Footer/component"

import developmenttImg from "../../assets/img/demo/developmentt_img.jpg"
import rightArrowbg from "../../assets/img/right_arrow_bg_black.png"
import rightArrowBg from "../../assets/img/right_arrow_bg.png"
import pageBannerbg from "../../assets/img/page_banner_bg.svg"


import "./styles.scss"

export default function ServiceInsideComponent() {
  useEffect(() => {
    window.scrollTo(0, 0)
  });
  
  return (
    <>
      <main id="main" className="site-main content-no-spacing web__development-wrapper">
        <HeaderComponent />
        <div className="content">
          <div className="clearfix">
            <section className="page__banner">
              <img className="page__banner-bg" src={pageBannerbg} alt=""/>
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="entry-banner">
                      <h1 className="entry-title">Web Development</h1>
                      <div className="breadcrumb-area">
                        <div className="entry-breadcrumb">
                          <li className="active">
                            <a href="#">Bubble</a>
                          </li>
                          <li className="active">
                            <a href="#">Services</a>
                          </li>
                          <li>
                            <a href="#">Web Development</a>
                          </li>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* <section id="page-title" className="page-title-ml content-top-spacing">             
              <div className="wrapper">
                <div className="title">
                  <h1 className="large">Strategic Planning</h1>
                </div>

                <div className="title-opacity">
                  <div className="title-opacity-text">Planning</div>
                </div>

                <div className="description spacer p-top-lg">
                  <p>
                    A business consulting company is involved in the planning, implementation, and education of businesses. We work directly with business owners on developing a business plan, identifying marketing needs and
                    developing the necessary skills for business ownership.
                  </p>
                </div>
              </div>
            </section> */}

            <section className="post-thumb-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <img className="img-thumbnail img-fluid" src={developmenttImg} alt=""/>
                  </div>
                </div>
                <div className="post-thumb-info">
                  <div className="email__id">Email:<span>sales@codebubbletech.com</span></div>
                  <div className="thumb-text-inner">
                    <p>Web Development is a process of turning ideas into functional web pages. It includes programming and software engineering, interface design, writing markup and style sheets, client-side scripting such as JavaScript and AJAX among other things.</p>
                    <p>Web development teams comprise of designers, writers, analysts, or researchers as well as developers.</p>
                  </div>                  
                </div>
              </div>
            </section>

            <section className="elementor__section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <ul className="elementor__list">
                      <li className="items responsive">
                        <div className="count one">1</div>
                        <h3>Fully Responsive</h3>
                      </li>
                      <li className="items device__testing">
                        <div className="count two">2</div>
                        <h3>Device Testing</h3>
                      </li>
                      <li className="items clean__modern">
                        <div className="count three">3</div>
                        <h3>Clean & Modern</h3>
                      </li>
                      <li className="items great__experience">
                        <div className="count four">4</div>
                        <h3>Great Experience</h3>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <button className="btn btn-outline-secondary about-btn" onClick={() => window.location.assign('/about-us')}>About us
              <img className="icon icon_black" src={rightArrowbg} alt="" />
              <img className="icon icon_white" src={rightArrowBg} alt="" />
            </button>

            {/* <div id="video" className="block spacer p-top-xl">
              <div className="wrapper">
                <div className="embed">
                  <div className="embed-image-overlay">
                    <a className="embed-click swipebox" href="https://www.youtube.com/watch?v=lSNmfy_KOJg">
                      <div className="embed-center">
                        <div className="embed-play">
                          <i className="fas fa-play"></i>
                        </div>
                      </div>
                    </a>

                    <div className="embed-image">
                      <div className="img object-fit">
                        <div className="object-fit-cover">
                          <img src="/img/demo/10_img.jpg" alt="Video" />
                        </div>
                      </div>
                    </div>

                    <div className="embed-bg"></div>
                  </div>
                </div>
              </div>
            </div> */}


            {/* <section id="how-it-works" className="block bg-white before-block">
              <div className="wrapper">
                <div className="row no-gutters process-height">
                  <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <div className="process pl-0">
                      <div className="process-content">
                        <h6 className="process-small-t-head">How it Works?</h6>

                        <div className="process-description">
                          <h2>We Guarantee a Stable Work Process</h2>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <div className="process process-color-1">
                      <div className="process-content">
                        <h4 className="process-t-head">Business Analysis</h4>
                        <p className="process-description">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium.</p>
                      </div>

                      <div className="process-number">01</div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <div className="process process-color-2">
                      <div className="process-content">
                        <h4 className="process-t-head">Business Planning</h4>
                        <p className="process-description">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium.</p>
                      </div>

                      <div className="process-number">02</div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <div className="process process-color-3">
                      <div className="process-content">
                        <h4 className="process-t-head">Business Growth</h4>
                        <p className="process-description">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium.</p>
                      </div>

                      <div className="process-number">03</div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}


            {/* <section id="price-plans" className="block spacer p-top-xl">
              <div className="wrapper">
                <div className="title">
                  <h6 className="text-primary text-uppercase">Price Plans</h6>
                </div>

                <div className="title-opacity">
                  <div className="title-opacity-text">Plans</div>
                </div>

                <div className="description">
                  <h2>Choose the Best Plan for You</h2>
                </div>

                <div className="row gutter-width-md with-pb-md spacer p-top-lg">
                  <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div className="price-table">
                      <div className="price-table-header">
                        <h4 className="price-table-t-head">Basic Plan</h4>
                        <p className="price-table-description">This is Basic Plan</p>
                      </div>

                      <div className="price-table-price">
                        <p><span className="currency">$</span><span className="price">79</span><span className="period">/ Monthly</span></p>
                      </div>

                      <ul className="price-table-list-group list-group">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Branding
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          20 hours of consultation
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          15 hours if theory
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Skype video call
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Support 24/7
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>
                      </ul>

                      <div className="price-table-footer">
                        <a href="#" className="btn btn-outline-secondary" data-toggle="modal" data-target="#plans-modal" data-whatever="Basic Plan">Choose Plan</a>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div className="price-table">
                      <div className="price-table-header">
                        <h4 className="price-table-t-head">Standart Plan</h4>
                        <p className="price-table-description">This is Standart Plan</p>
                      </div>

                      <div className="price-table-price">
                        <p><span className="currency">$</span><span className="price">129</span><span className="period">/ Monthly</span></p>
                      </div>

                      <ul className="price-table-list-group list-group">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Branding
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          20 hours of consultation
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          15 hours if theory
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Skype video call
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Support 24/7
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>
                      </ul>

                      <div className="price-table-footer">
                        <a href="#" className="btn btn-outline-secondary" data-toggle="modal" data-target="#plans-modal" data-whatever="Standart Plan">Choose Plan</a>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div className="price-table">
                      <div className="price-table-badge">
                        <p>Popular</p>
                      </div>

                      <div className="price-table-header">
                        <h4 className="price-table-t-head">Premium Plan</h4>
                        <p className="price-table-description">This is Premium Plan</p>
                      </div>

                      <div className="price-table-price">
                        <p><span className="currency">$</span><span className="price">259</span><span className="period">/ Monthly</span></p>
                      </div>

                      <ul className="price-table-list-group list-group">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Branding
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          20 hours of consultation
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          15 hours if theory
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Skype video call
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Support 24/7
                          <i className="text-primary fas fa-check i-small"></i>
                        </li>
                      </ul>

                      <div className="price-table-footer">
                        <a href="#" className="btn btn-outline-secondary" data-toggle="modal" data-target="#plans-modal" data-whatever="Premium Plan">Choose Plan</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}


            {/* <div id="clients" className="block bg-white spacer m-top-xl">
              <div className="wrapper">
                <div className="clients">
                  <div className="clients-items">
                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="/img/demo/06_img.png" alt="Balkan" />
                      </div>
                    </div>

                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="/img/demo/07_img.png" alt="Adveits" />
                      </div>
                    </div>

                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="/img/demo/08_img.png" alt="Swiger" />
                      </div>
                    </div>

                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="/img/demo/09_img.png" alt="The mandala community" />
                      </div>
                    </div>

                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="/img/demo/06_img.png" alt="Balkan" />
                      </div>
                    </div>

                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="/img/demo/07_img.png" alt="Adveits" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

          </div>
        </div>
      </main>

       
      <FooterComponent />
    </>
  )
}
